"use strict";

const mobileNav = document.querySelector("#mobile-navigation");
const burgerMenu = document.querySelector("swiftref-nav-toggle");

function _toggle (event) {
    if (mobileNav.classList.toggle("visible")) {
        burgerMenu.setAttribute("aria-expanded", "true");
    } else {
        burgerMenu.setAttribute("aria-expanded", "false");
    }
}
if (burgerMenu) {
    burgerMenu.addEventListener("click", _toggle);
}

